import React from 'react';
import { Text, Switch, Box } from '@rsos/base-components';
import useIsIRP from '@rsos/utils/useIsIRP';
import SoundSelect from '../SoundSelect';
import { trackToggleSoundOnOff } from '../audioSettingsTrackings';
import { Wrapper, SoundBlock } from './SoundControlCard.styles.js';

const SoundControlCard = ({ audioSettings, updateAudioSettings }) => {
  const { irpVersion } = useIsIRP();
  const { sound_on: isSoundOn, tone } = audioSettings;

  const toggleSoundOn = () => {
    updateAudioSettings({ sound_on: !isSoundOn });
    trackToggleSoundOnOff(irpVersion, isSoundOn);
  };

  return (
    <Wrapper>
      <Box>
        <Text size="large" fontWeight="bold" mb="2px">
          Alerts
        </Text>
        <Text size="normal">
          Notify your agents with sound when new alerts appear in the queue.
        </Text>
      </Box>
      <SoundBlock>
        <Text size="normal">Sound Notification</Text>
        <Switch onOffLabel onClick={toggleSoundOn} isOn={isSoundOn} />
      </SoundBlock>
      <SoundSelect
        isSoundOn={isSoundOn}
        tone={tone}
        updateAudioSettings={updateAudioSettings}
      />
    </Wrapper>
  );
};

export default SoundControlCard;
